import p5Types from "p5";
import { Rect } from "../util";

export type Move = "left" | "right" | "idle";

export default abstract class AsteroidAgent {
  public rect: Rect;
  public isAlive: boolean = true;

  constructor(rect: Rect) {
    this.rect = rect;
  }

  public abstract update(asteroidRect: Rect, p5: p5Types): Move;
  public onDie(_: number): void {}
}
